import { render } from "./SC_lic.vue?vue&type=template&id=31a11022"
import script from "./SC_lic.vue?vue&type=script&lang=js"
export * from "./SC_lic.vue?vue&type=script&lang=js"

import "./SC_lic.vue?vue&type=style&index=0&id=31a11022&lang=css"

import exportComponent from "C:\\Users\\sisco\\Documents\\Compras\\SC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__